import { useTrpc } from '~/composables/_next/useTrpc';
import { useLocalization } from '~/composables/_next/useLocalization';

export function useContentful() {
  const { locale } = useLocalization();
  const { client } = useTrpc();

  return {
    search(params: object, nestedFields = []) {
      return client.contentful.getEntries.query({
        params: {
          locale,
          ...params,
        },
        nestedFields,
      });
    },
  };
}
